// @flow
import { ThemeProvider } from "styled-components";
import { renderRoutes } from "react-router-config";
import { theme, GlobalStyles } from "@nested/ui";

type Props = RouteProps<{}>;

export const UniversalRender = ({ route: { routes } }: Props) => (
  <ThemeProvider theme={theme}>
    <GlobalStyles />
    {renderRoutes(routes)}
  </ThemeProvider>
);
